import { render, staticRenderFns } from "./ActivityInfo.vue?vue&type=template&id=0fe98928&scoped=true"
import script from "./ActivityInfo.vue?vue&type=script&lang=ts"
export * from "./ActivityInfo.vue?vue&type=script&lang=ts"
import style0 from "./ActivityInfo.vue?vue&type=style&index=0&id=0fe98928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe98928",
  null
  
)

export default component.exports